import React from "react";
import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import PowerCharts from "fusioncharts/fusioncharts.powercharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { licenseKey } from "./license";
import { KeyValue } from "../../interfaces";

ReactFC.fcRoot(FusionCharts, PowerCharts, FusionTheme);

(FusionCharts as KeyValue).options["license"]({
  key: licenseKey,
  creditLabel: false,
});

interface Props {
  amount: number;
  rangeMinValue: number;
  rangeMaxValue: number;
}

export default function HeatBoxIcon({
  amount,
  rangeMinValue,
  rangeMaxValue,
}: Props) {
  const value = amount ? amount : 0;
  let inRange = true;

  rangeMinValue = rangeMinValue / 1000;
  rangeMaxValue = rangeMaxValue / 1000;

  if (value > rangeMaxValue || value < rangeMinValue) {
    inRange = false;
  }

  const colorRange = {
    minvalue: 0,
    startlabel: "Low",
    endlabel: "High",
    code: "#FFFFA2",
    gradient: "1",
    color: [
      {
        maxvalue: 1000000000,
        code: "#ED4630",
        displayValue: "Median",
      },
      {
        maxvalue: 3000000000,
        code: "#B2D1FD",
      },
    ],
  };

  const colorRangeAllWhite = {
    minvalue: 0,
    startlabel: "Low",
    endlabel: "High",
    code: "#FFFFFF",
    gradient: "1",
    color: [
      {
        maxvalue: 1000000000,
        code: "#FFFFFF",
        displayValue: "Median",
      },
      {
        maxvalue: 3000000000,
        code: "#FFFFFF",
      },
    ],
  };

  const colorRangeNoData = {
    minvalue: 0,
    startlabel: "Low",
    endlabel: "High",
    code: "#aeaeae",
    gradient: "1",
    color: [
      {
        maxvalue: 1000000000,
        code: "#aeaeae",
        displayValue: "Median",
      },
      {
        maxvalue: 3000000000,
        code: "#aeaeae",
      },
    ],
  };

  const colorRangeUpdated =
    value === 0 ? colorRangeNoData : inRange ? colorRange : colorRangeAllWhite;

  const heatBox = {
    type: "heatmap",
    renderAt: "chart-container",
    width: "45",
    height: "33",
    dataFormat: "json",
    dataSource: {
      chart: {
        theme: "fusion",
        plotBorderColor: "#000000",
        showPlotBorder: "1",
        showLegend: "0",
        showTooltip: "0",
        showLabels: "0",
        chartBottomMargin: "0",
        chartTopMargin: "0",
        showHover: "0",
        plotHOverEffect: "0",
      },
      rows: {
        row: [
          {
            id: "Row1",
            label: "test1",
          },
        ],
      },
      columns: {
        column: [
          {
            id: "Column1",
            label: "test2",
          },
        ],
      },
      dataset: [
        {
          data: [
            {
              rowid: "Row1",
              columnid: "Column1",
              value: `${value}`,
            },
          ],
        },
      ],
      colorrange: colorRangeUpdated,
    },
  };
  return (
    <div className="heat-box-icon">
      {/* @ts-ignore */}
      <ReactFC {...heatBox} />
    </div>
  );
}
